import { Route, Routes } from 'react-router-dom';
import './App.scss';
import Main from './components/Main';
import RequireAuth from './components/RequireAuth';
import { Error, Dashboard, DTR, MyDTR, Payperiod, Shift, Shiftschedule, Timesheets, Child, Parent, Grandchild, Employees, View, Timesheet, Approved, Disapproved, Adjustment, SettingDevices, LogLocations, LogActions, Department, SettingApprovals, Departmental, Events, LeavesOutlet, MyLeaves, Leaves, Credits, ShiftscheduleDepartmental, CreditsDepartmental, LeaveApproval, LeaveDisapproval, LeaveAttachment, NDOTOutlet, MyRequest, NDOTSettings, NDOTApproval, NDOTDisapproval, NDOTAttachment, NDOTRequests, LeaveRequests, LeaveRequestsDepartmental, NDOTRequestsDepartmental, ReportOutlet, Attendance, ReportYears, ReportPayperiods, ReportDepartments } from './modules';
import Authenticate from './modules/Authenticate';
import TimesheetOutlet from './modules/dtr/nopriv/TimesheetOutlet';
import SettingsOutlet from './modules/settings/SettingsOutlet';
import LogsOutlet from './modules/logs/LogsOutlet';
import LeaveApprovalDisapprovalOutlet from './modules/leaves/nopriv/LeaveApprovalDisapprovalOutlet';
import NDOTApprovalDisapprovalOutlet from './modules/ndot/nopriv/NDOTApprovalDisapprovalOutlet';

function App() {
    return (
        <Routes>
            <Route path='/' element={<Main />}>
                <Route path='authenticate' element={<Authenticate />} />
                <Route path='error' element={<Error />} />
                
                {/* Authenticated Routes */}
                <Route element={<RequireAuth />}>
                    <Route path='dashboard' element={<Dashboard />} />
                    <Route path='dtr' element={<DTR />} >
                        <Route path='my-dtr' element={<MyDTR />} />
                        <Route path='pay-periods' element={<Payperiod />} />
                        <Route path='shift-schedules' element={<Shiftschedule />} />
                        <Route path='shift-schedules/:any' element={<ShiftscheduleDepartmental />} />
                        <Route path='shifts' element={<Shift />} />
                        <Route path='timesheets' element={<Timesheets />} >
                            <Route path='' element={<Parent />} />
                            <Route path=':any' element={<Child />} />
                            <Route path=':any/:any' element={<Grandchild />} />
                            <Route path=':any/:any/:any' element={<Employees />} />
                            <Route path=':any/:any/:any/:any' element={<View />} />
                        </Route>
                    </Route>
                    <Route path='leaves' element={<LeavesOutlet />} >
                        <Route path='my-leave' element={<MyLeaves />} />
                        <Route path='requests' element={<LeaveRequests />} />
                        <Route path='requests/:any' element={<LeaveRequestsDepartmental />} />
                        <Route path='credits' element={<Credits />} />
                        <Route path='credits/:any' element={<CreditsDepartmental />} />
                    </Route>
                    <Route path='nd-ot' element={<NDOTOutlet />} >
                        <Route path='my-request' element={<MyRequest />} />
                        <Route path='all-requests' element={<NDOTRequests />} />
                        <Route path='all-requests/:any' element={<NDOTRequestsDepartmental />} />
                    </Route>
                    <Route path='reports' element={<ReportOutlet />} >
                        <Route path='' element={<ReportDepartments />} />
                        <Route path=':any' element={<ReportYears />} />
                        <Route path=':any/:any' element={<ReportPayperiods />} />
                        <Route path=':any/:any/:any' element={<Attendance />} />
                    </Route>
                    <Route path='settings' element={<SettingsOutlet />} >
                        <Route path='devices' element={<SettingDevices />} />
                        <Route path='approvals' element={<SettingApprovals />} />
                        <Route path='approvals/:any' element={<Departmental />} />
                        <Route path='events' element={<Events />} />
                        <Route path='leave' element={<Leaves />} />
                        <Route path='ndot' element={<NDOTSettings />} />
                    </Route>
                    <Route path='logs' element={<LogsOutlet />} >
                        <Route path='actions' element={<LogActions />} />
                        <Route path='locations' element={<LogLocations />} />
                    </Route>
                </Route>

                {/* Unauthenticated Routes */}
                <Route path='timesheet' element={<TimesheetOutlet />} >
                    <Route path='department' element={<Department />} />
                    <Route path='view' element={<Timesheet />} />
                    <Route path='approve' element={<Approved />} />
                    <Route path='disapprove' element={<Disapproved />} />
                    <Route path='adjustment' element={<Adjustment />} />
                </Route>
                <Route path='leave' element={<LeaveApprovalDisapprovalOutlet />} >
                    <Route path='approve' element={<LeaveApproval />} />
                    <Route path='disapprove' element={<LeaveDisapproval />} />
                    <Route path='attachment' element={<LeaveAttachment />} />
                </Route>
                <Route path='ndot' element={<NDOTApprovalDisapprovalOutlet />} >
                    <Route path='approve' element={<NDOTApproval />} />
                    <Route path='disapprove' element={<NDOTDisapproval />} />
                    <Route path='attachment' element={<NDOTAttachment />} />
                </Route>

                {/* 404 Route */}
                <Route path='*' element={<Error />} />
            </Route>
        </Routes>
    );
}

export default App;
